module.exports = __webpack_public_path__ + "img/calendar.2fc67d8.svg";